import { ArrayInput, TextField } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { ListIterator } from "../../common/list/compact-list/ListIterator";
import resourceNames from "../../../common/data/resourceNames";
import { useForm } from "react-final-form";

interface Props {}

export const VehicleSelectionGrid = (props: Props) => {
  const form = useForm();
  const isAllVehiclesSelectedState = form.getFieldState(
    "isAllVehiclesSelected"
  );

  return (
    <div
      style={{ display: isAllVehiclesSelectedState?.value ? "none" : "block" }}
    >
      <ProtectedElement source="selectedVehicles" label="" {...props}>
        <ArrayInput source="selectedVehicles">
          <ListIterator
            reference={resourceNames.ADMIN_VEHICLES}
            sort={{ field: "name", order: "asc" }}
          >
            <TextField
              source="name"
              label="resources.admin-vehicles.labels.vehicleId"
            />
          </ListIterator>
        </ArrayInput>
      </ProtectedElement>
    </div>
  );
};
